const moment = require('moment');
import { IKeyValue } from 'motw_core/Entity/IKeyValue';

export const IsKeyValueExpired = (keyValue: IKeyValue) => {
	if (keyValue === undefined) {
		return false;
	}

	if (keyValue.expiry === 0) {
		return false;
	}

	const isKeyValueExpired =
		moment().diff(moment(keyValue.lastmodifiedtime), 'minutes') >
		keyValue.expiry;

	return isKeyValueExpired;
};
